/**
 * Content Action Entity
 * Represents an action that can be performed on a piece of content
 *
 * Matches Flutter implementation: lib/domain/enums/content_action_type.dart
 *                                 lib/domain/entity/bottom_sheet/content_action.dart
 */

export enum ContentActionType {
  SHARE = 'share',
  SHARE_SOCIAL = 'shareSocial',
  REPORT = 'report',
  SAVE = 'save',
  COPY = 'copy',
  PUBLISH_DRAFT = 'publishDraft',
  DELETE = 'delete',
  LINK = 'link',
  UNLINK = 'unlink',
  APPEAL = 'appeal',
  SCHEDULE_CONTENT = 'scheduleContent',
  PROCESSING = 'processing',
  HIDE = 'hide',
}

export interface ContentActionEntity {
  image: string;
  name: string;
  type: ContentActionType;
}
